import gsap from 'gsap';
import { CUSTOM_EVENTS } from '../lib/constants';

const els = document.querySelectorAll('.js-vertical-accordion');

function verticalAccordion(el: HTMLElement) {
  const head = el.querySelector<HTMLElement>('[data-accordion-head]');
  const content = el.querySelector<HTMLElement>('[data-accordion-content]');
  if (!head || !content) return;
  
  const { disabled } = head.dataset;

  if (disabled !== undefined) return;

  let isOpen = false;

  const handleClick = () => {
    isOpen = !isOpen;
    el.classList.toggle('open');

    gsap.to(content, {
      height: isOpen ? content.scrollHeight : 0,
    });

    gsap.to(content?.children, {
      opacity: isOpen ? 1 : 0,
      y: isOpen ? 0 : 20,
    });

    head.setAttribute('aria-expanded', String(isOpen));
  };

  const handleScrolledTo = () => {
    if (!isOpen) handleClick();
  };

  gsap.set(content?.children, {
    opacity: 0,
    y: 20,
  });

  head.addEventListener('click', handleClick);
  el.addEventListener(CUSTOM_EVENTS.scrolledTo, handleScrolledTo);
}

els.forEach(verticalAccordion);
